import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { YukiSettings } from '../../models/yuki/YukiSettings';
import { UpdateYukiSettings } from '../yuki.actions';

@Component({
    selector: 'app-ai-sync-settings',
    templateUrl: './ai-sync-settings.component.html',
    styleUrls: ['./ai-sync-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AiSyncSettingsComponent implements OnInit, OnDestroy {
    @Input() yukiSettings: YukiSettings;
    runAiOnSync = true;
    nightlySyncEnabled = true;

    private subscriptions = new Subscription();

    constructor(public activeModal: NgbActiveModal, private store: Store, private toastr: ToastrService, private logger: NGXLogger) {}

    ngOnInit(): void {
        this.runAiOnSync = this.yukiSettings?.runAiOnSync !== false;
        this.nightlySyncEnabled = this.yukiSettings?.nightlySyncEnabled !== false;
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    updateRunAiOnSync() {
        this.runAiOnSync = !this.runAiOnSync;
        const yukiSettings: YukiSettings = {
            runAiOnSync: this.runAiOnSync,
        };

        this.subscriptions.add(
            this.store.dispatch(new UpdateYukiSettings(this.yukiSettings.uuid, yukiSettings)).subscribe(
                () => {
                    this.toastr.success('Instelling bijgewerkt');
                },
                () => {
                    this.runAiOnSync = !this.runAiOnSync;
                    this.logger.error('Failed to update Yuki settings');
                    this.toastr.error('Oops, er ging iets mis. Probeer het later opnieuw...');
                },
            ),
        );
    }

    updateNightlySyncEnabled() {
        this.nightlySyncEnabled = !this.nightlySyncEnabled;
        const yukiSettings: YukiSettings = {
            nightlySyncEnabled: this.nightlySyncEnabled,
        };

        this.subscriptions.add(
            this.store.dispatch(new UpdateYukiSettings(this.yukiSettings.uuid, yukiSettings)).subscribe(
                () => {
                    this.toastr.success('Instelling bijgewerkt');
                },
                () => {
                    this.nightlySyncEnabled = !this.nightlySyncEnabled;
                    this.logger.error('Failed to update Yuki settings');
                    this.toastr.error('Oops, er ging iets mis. Probeer het later opnieuw...');
                },
            ),
        );
    }
}
